import { OrderedAnnotationResultsProcessor } from './ordered-annotation-results-processor';
import { UnorderedAnnotationResultsProcessor } from './unordered-annotation-results-processor';
export class RoutingAnnotationResultsProcessor {
    constructor(isOrderingEnabled, orderedAnnotationResultsProcessor, unorderedAnnotationResultsProcessor) {
        this.isOrderingEnabled = isOrderingEnabled;
        this.orderedAnnotationResultsProcessor = orderedAnnotationResultsProcessor !== null && orderedAnnotationResultsProcessor !== void 0 ? orderedAnnotationResultsProcessor : new OrderedAnnotationResultsProcessor();
        this.unorderedAnnotationResultsProcessor = unorderedAnnotationResultsProcessor !== null && unorderedAnnotationResultsProcessor !== void 0 ? unorderedAnnotationResultsProcessor : new UnorderedAnnotationResultsProcessor();
    }
    process(message, applyItem, onOperationProcessed, onMessageProcessed) {
        if (this.isOrderingEnabled()) {
            this.orderedAnnotationResultsProcessor.process(message, applyItem, onOperationProcessed, onMessageProcessed);
        }
        else {
            this.unorderedAnnotationResultsProcessor.process(message, applyItem, onOperationProcessed, onMessageProcessed);
        }
    }
}
//# sourceMappingURL=routing-annotation-results-processor.js.map